import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import React from "react"
import { createBfzArticleTeaserLink } from "components/page-components/Teaser-Cards/utils"

export const AdvertorialTwo = ({ advertorialTwo }) => {
  const advertorial_link = createBfzArticleTeaserLink(advertorialTwo)

  return (
    <div
      data-nosnippet={true}
      className="py-6 mb-6 has-background-mitternachtsblau-5"
      style={{ position: "relative" }}
    >
      <div className="columns is-centered is-gapless mb-0">
        <div className="column is-9-desktop is-12-touch">
          <Link to={advertorial_link}>
            <div className="columns is-vcentered is-centered">
              <div className="column is-4-desktop is-full-mobile has-text-centered">
                <GatsbyImage
                  image={
                    advertorialTwo?.thumbnail?.childImageSharp?.gatsbyImageData
                  }
                  alt={advertorialTwo?.headline}
                  title={advertorialTwo?.headline}
                  className="hoverzoom"
                />
              </div>
              <div className="column">
                <p className="has-text-mitternachtsblau title is-6">
                  {advertorialTwo?.headline}
                </p>
                <p
                  className="help has-text-mitternachtsblau"
                  style={{
                    textOverflow: "ellipsis",
                    WebkitLineClamp: "3",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    overflow: "hidden",
                  }}
                >
                  {advertorialTwo?.teaser_short}
                </p>
              </div>
            </div>
          </Link>
        </div>
      </div>
      <div
        className="ad-disclaimer"
        style={{ position: "absolute", right: 15, bottom: 10 }}
      >
        Anzeige
      </div>
    </div>
  )
}
